@if (showCheckbox) {
    <cc-checkbox
        [disabled]="disabled"
        [(value)]="value"
        (valueChange)="onClick($event)"
    >
    </cc-checkbox>
}
